// Home.js
// Redux Container for Home View

// Imports
import { connect } from 'react-redux';
import HomeView from '../components/HomeView';

// State Mapper
const mapStateToProps = state => ({

});

// Exports
export default connect(mapStateToProps)(HomeView);


// WEBPACK FOOTER //
// ./src/containers/Home.js